import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "container", "requiredInput"]

  connect() {
    this.toggle()
  }

  fire(event) {
    this.updateVisibility(event.target.checked)
  }

  toggle() {
    this.updateVisibility(this.checkboxTarget.checked)
  }

  updateVisibility(isVisible) {
    this.containerTarget.classList.toggle("hidden", !isVisible)

    this.requiredInputTargets.forEach(input => {
      input.required = isVisible
      input.disabled = !isVisible
    })
  }
}
